import PropTypes from 'prop-types';
import {Component} from 'react';
import {Button} from 'semantic-ui-react';
import BackToTop from '../images/chevron-black.png';
import './ScrollToTop.scss';

export class ScrollToTop extends Component {
  static propTypes = {
    showBackToTop: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      showBackToTop: props ? props.showBackToTop : false,
    };
  }

  componentDidMount() {
    const {showBackToTop} = this.props;
    this.setState({
      showBackToTop,
    });
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  goBackToTop = (e) => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    this.handleScroll(e);
  };

  handleScroll = (event) => {
    this.setState({showBackToTop: document.documentElement.scrollTop > 20});
  };

  render() {
    const showBackToTop = this.state.showBackToTop;
    return (
      <div className={`back-to-top${showBackToTop ? ' showing' : ''}`}>
        <Button
          className="button-tertiary go-back-button"
          onClick={this.goBackToTop}
        >
          <img src={BackToTop} alt="back to top"/>
        </Button>
        <p>Back to top</p>
      </div>
    );
  }
}
